import React, { FC, useContext } from "react";
import { LocalizationContext } from "v3/context/localization";
import { SubmittedOrderQuery } from "v3/services/graphql/generated";
import { FulfillmentItem } from "./Item";
import { StyledNote } from "./index.styled";

interface FulfillmentsProps {
  fulfillments?: NonNullable<
    SubmittedOrderQuery["submittedOrder"]
  >["fulfillments"];
}

export const Fulfillments: FC<FulfillmentsProps> = ({ fulfillments }) => {
  const { localization } = useContext(LocalizationContext);
  const {
    orderConfirmationShipmentText = "Please note that in order to ensure faster delivery, one order may consist of " +
      "multiple packages delivered on different days.",
  } = localization?.checkout?.orderStatusPage || {};
  return (
    <>
      {!fulfillments || fulfillments.length === 0 ? (
        <StyledNote>{orderConfirmationShipmentText}</StyledNote>
      ) : (
        <>
          {fulfillments.map((fulfillment) => (
            <FulfillmentItem fulfillment={fulfillment} key={fulfillment.id} />
          ))}
        </>
      )}
    </>
  );
};
